import type { ReactElement } from 'react';
import { LandingNav } from './landing/LandingNav';
import { HeroSection } from './landing/HeroSection';
import { SpacesGallery } from './landing/SpacesGallery';
import { UseCases } from './landing/UseCases';
import { MCPIntegration } from './landing/MCPIntegration';
import { Pricing } from './landing/Pricing';
import { Footer } from './landing/Footer';

export function LandingPage(): ReactElement {
  return (
    <div className="landing-root">
      {/* Fixed background effects */}
      <div className="landing-grid-bg" />
      <div className="landing-noise" />
      <div className="landing-scanline" />

      <LandingNav />
      <HeroSection />
      <SpacesGallery />
      <UseCases />
      <MCPIntegration />
      <Pricing />
      <Footer />
    </div>
  );
}
